import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
// material
import { Card, CardHeader, Box, Dialog } from "@mui/material";
import { BaseOptionChart } from "src/components/charts";
import FormDialog from "src/components/common/FormDialog";
//

// ----------------------------------------------------------------------

const CHART_DATA = [
  // {
  //   name: "扫码",
  //   type: "column",
  //   data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
  // },
  {
    name: "搜索",
    type: "area",
    data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
  },
  {
    name: "链接",
    type: "line",
    data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
  },
];

export default function RangliTrend({ title, labels, data, onClose }) {

  console.log(title, labels, data)

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: "11%", borderRadius: 4 } },
    fill: { type: ["gradient", "solid"] },
    labels: ["2021/01/01", "2021/02/01", "2021/03/01", "2021/04/01", "2021/05/01", "2021/06/01", "2021/07/01", "2021/08/01", "2021/09/01", "2021/10/01", "2021/11/01"],
    labels,
    xaxis: { type: "datetime" },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== "undefined") {
            return `${y.toFixed(0)}元`;
          }
          return y;
        },
      },
    },
  });

  return (
    <FormDialog title={title} open onClose={onClose} onConfirm={onClose}>
      <Card sx={{ width: 800 }}>
        {/* <CardHeader title="小程序访问量" subheader="" /> */}
        <Box sx={{ p: 3, pb: 1 }} dir="ltr">
          <ReactApexChart type="line" series={data} options={chartOptions} height={364}  />
        </Box>
      </Card>
    </FormDialog>
  );
}
